import { useEffect, useState } from 'react';
import { policyService } from 'api/services/PolicyService';
import { WHATSAPP_DISCLOSURE_POLICY_SLUG } from 'constants/listingContactMethod';

export function useWhatsappSellerDisclosure() {
  const [isPending, setIsPending] = useState(true);
  const [policyId, setPolicyId] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      setLoading(true);
      try {
        const result = await policyService.getPendingPolicies();
        const match = (result.data ?? []).find((p) => p.slug === WHATSAPP_DISCLOSURE_POLICY_SLUG);
        if (!cancelled) {
          setIsPending(Boolean(match));
          setPolicyId(match?.id ?? null);
        }
      } catch {
        if (!cancelled) {
          setIsPending(true);
          setPolicyId(null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { isPending, policyId, loading };
}
